import { useEffect, useState } from 'react';
import accountApis from '../../../../../services/accountApis';
import { AxiosResponse } from 'axios';
import { IScreenWaiting } from '../types';

const useGetScreenWaiting = (shopId: string) => {
  const [data, setData] = useState<IScreenWaiting[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res: AxiosResponse<{ data: IScreenWaiting[] }> = await accountApis.getThemeCheckInWaiting(shopId);
      setData(res?.data?.data);
    } catch (error) {
      console.error('Error fetching screen waiting data:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (shopId) {
      fetchData();
    }
  }, [shopId]);

  return { data, loading, refetch: fetchData };
};

export default useGetScreenWaiting;
